import { updateFilter, setFilterParams } from 'features/patients-list/patientSlice'
import {
    updateFilter as cupdateFilter,
    setFilterParams as csetFilterParams,
} from 'features/collections-list/collectionSlice'
import { arrayPartition } from 'utils/helpers'
import { generateFilter } from 'utils/filter'

export function tagListeners(startListening) {
    const subscriptions = [
        startListening({
            predicate: ({ type, meta }, currentState) => {
                const { endpointName, originalArgs } = meta.arg
                if (
                    type === 'api/executeQuery/fulfilled' &&
                    endpointName === 'getTags' &&
                    originalArgs === undefined &&
                    !currentState.patients.isFiltered
                ) {
                    return true
                }
                return false
            },
            effect: ({ payload }, listenerApi) => {
                const mergedTags = ['all', ...payload]

                // listenerApi.dispatch(updateFilter({ key: 'tag', value: mergedTags }))
                // listenerApi.dispatch(cupdateFilter({ key: 'tag', value: mergedTags }))
            },
        }),
        startListening({
            predicate: ({ type, meta }, currentState) => {
                const { endpointName, originalArgs } = meta.arg
                if (
                    type === 'api/executeQuery/fulfilled' &&
                    endpointName === 'getTags' &&
                    originalArgs === undefined &&
                    currentState.patients.isFiltered
                ) {
                    return true
                }
                return false
            },
            effect: ({ payload }, listenerApi) => {
                const { patients } = listenerApi.getState()
                const [all, tags] = arrayPartition(patients.filter.tag, t => t === 'all')
                const availableTags = tags.filter(t => payload.includes(t))
                const generatedFilter = generateFilter([{ tag: availableTags }])
                const mergedTags = [...all, ...availableTags]

                listenerApi.dispatch(updateFilter({ key: 'tag', value: mergedTags }))
                listenerApi.dispatch(cupdateFilter({ key: 'tag', value: mergedTags }))
                listenerApi.dispatch(setFilterParams({ type: 'filter', value: generatedFilter }))
                listenerApi.dispatch(csetFilterParams({ type: 'filter', value: generatedFilter }))
            },
        }),
    ]
    return () => {
        subscriptions.forEach(unsubscribe => unsubscribe())
    }
}
